/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { downloadAttachment } from './actions';
import DownloadIcon from '@icons/download-icon';
import { Button } from '@mui';
import './download-all.scss';

const DownloadAll = ({ attachments }) => {
  const download = () => {
    for (let index = 0; index < attachments.length; index += 1) {
      setTimeout(() => {
        downloadAttachment(attachments[index]);
      }, (index + 1) * 1000);
    }
  };

  return (
    <div styleName="container" onClick={download} role="presentation">
      <Button size="small" startIcon={<DownloadIcon />} style={{ textTransform: 'none' }}>
        Download all
      </Button>
    </div>
  );
};

DownloadAll.propTypes = {
  attachments: PropTypes.array
};

export default DownloadAll;
